<template>
  <div class="feedback">
    <pageTitle v-bind="{ ...pT }" />
    <business-group
      ref="businessGroup"
      :tableConfig="{ ...tableConfig }"
      :formConfig="{ ...formConfig }"
    >
      <template slot="pictures" slot-scope="record">
        <m-image :url="record.pictures" />
      </template>
      <template slot="nickname" slot-scope="record">
        <div class="feedback-nickname">
          <m-image v-if="record.avatar" :size="40" :url="record.avatar"/>
          <span>{{ record.nickname }}</span>
        </div>
      </template>
    </business-group>
  </div>
</template>

<script>
import pageTitle from "@/components/business/pageTitle";
import businessGroup from "@/components/business/businessGroup";
import mImage from "@/components/business/mImage/mImage";

export default {
  components: {
    pageTitle,
    businessGroup,
    mImage
  },
  name: "feedback",
  created() {
    this.pT.pageTitle = this.$route?.meta?.title || "";
  },
  data() {
    return {
      pT: { pageTitle: "" },
      tableConfig: {
        url: "/bluetoothlight/web/other/feedbacks/service",
        columns: [
          {
            title: "您的问题与建议",
            dataIndex: "feedbackContent",
            key: "feedbackContent",
            align: "center",
          },
          {
            title: "上传的截图",
            dataIndex: "pictures",
            key: "pictures",
            align: "center",
            width: 200,
            scopedSlots: { customRender: "pictures" },
          },
          {
            title: "称呼",
            dataIndex: "nickname",
            key: "nickname",
            align: "center",
          },
          {
            title: "联系方式",
            key: "contactWay",
            dataIndex: "contactWay",
            align: "center",
          },
          {
            title: "提交人",
            key: "nickname",
            dataIndex: "nickname",
            align: "center",
            scopedSlots: { customRender: "nickname" },
          },

          {
            title: "提交时间",
            key: "createTime",
            dataIndex: "createTime",
            align: "center",
          },
        ],
        rowKey: "feedbackId",
      },
      formConfig: {
        formShow: false,
        hideHeader: true,
      },
    };
  },
};
</script>

<style lang="less">
.feedback-nickname {
  display: flex;
  align-items: center;
  justify-content: center;
  .Image {
    width: 40px;
    border-radius: 50%;
    border:1px solid rgb(230, 228, 228);
  }
}
</style>

